import Carousel from '@r1-frontend/ui-react/deprecated/carousel';
import PropTypes from 'prop-types';
import React from 'react';

import { CardNews } from '../card-news';
import * as ST from './styled';

const breakpoints = [
    { width: 0, slidesToShow: 1, showDots: true },
    { width: 768, slidesToShow: 2, showDots: true },
    { width: 1280, slidesToShow: 3, showDots: false },
];

export const ActualNews = ({ actualNews }) => {
    return (
            <ST.ActualNews>
                <ST.ActualNewsTitle>Актуальные новости</ST.ActualNewsTitle>
                <ST.ActualSliderWrap>
                        <Carousel showArrows={false} align='center' responsive={breakpoints}>
                            {actualNews.map(item => {
                                return (
                                    <ST.ActualCardWrap key={`card-${item.id}`}>
                                        <CardNews item={item} forSlider={true}/>
                                    </ST.ActualCardWrap>
                                );
                            })}
                        </Carousel>
                </ST.ActualSliderWrap>
            </ST.ActualNews>
    );
};

ActualNews.propTypes = {
    actualNews: PropTypes.array.isRequired,
};
